/**
 * Utilitários de cor do workspace (corWorkspace).
 */
export function adjustColorLightness (hex, percent) {
  if (!hex || typeof hex !== 'string') return '#5865F2'
  let normalized = hex.replace('#', '').trim()
  if (normalized.length === 3) {
    normalized = normalized.split('').map(c => c + c).join('')
  }
  if (normalized.length !== 6) return hex

  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)
  const factor = percent / 100
  const newR = Math.min(255, Math.max(0, Math.round(r + (255 - r) * factor)))
  const newG = Math.min(255, Math.max(0, Math.round(g + (255 - g) * factor)))
  const newB = Math.min(255, Math.max(0, Math.round(b + (255 - b) * factor)))
  const toHex = (n) => {
    const h = n.toString(16)
    return h.length === 1 ? `0${h}` : h
  }
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`
}

export function getWorkspaceAccentStyle (corWorkspace) {
  const accent = (corWorkspace && String(corWorkspace).trim()) || '#5865F2'
  return {
    '--ws-cli-accent': accent,
    '--ws-cli-accent-light': adjustColorLightness(accent, 20),
    '--ws-cli-accent-dark': adjustColorLightness(accent, -14)
  }
}
